import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {signIn, signOut, getCurrentUser, SignInOutput, confirmSignIn} from 'aws-amplify/auth';
import {FormGroup} from "@angular/forms";

export interface IUser {
  email: string;
  password: string;
  showPassword: boolean;
  code: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class CognitoService {

  private authenticationSubject: BehaviorSubject<any>;

  constructor() {
    this.authenticationSubject = new BehaviorSubject<boolean>(false);
  }

  // public signUp(user: IUser): Promise<any> {
  //   return Auth.signUp({
  //     username: user.email,
  //     password: user.password,
  //   });
  // }

  // public confirmSignUp(user: IUser): Promise<any> {
  //   return Auth.confirmSignUp(user.email, user.code);
  // }

  public async signIn(loginForm: FormGroup): Promise<SignInOutput> {
    return await signIn({
      username: loginForm.value.email,
      password: loginForm.value.password
    });
  }

  public signOut(): Promise<any> {
    return signOut()
    .then(() => {
      this.authenticationSubject.next(false);
    });
  }

  public isAuthenticated(): Promise<boolean> {
    if (this.authenticationSubject.value) {
      return Promise.resolve(true);
    } else {
      return this.getUser()
      .then((user: any) => {
        if (user) {
          return true;
        } else {
          return false;
        }
      }).catch(() => {
        return false;
      });
    }
  }

  public getUser(): Promise<any> {
    return getCurrentUser();
  }

  // public updateUser(user: IUser): Promise<any> {
  //   return Auth.currentUserPoolUser()
  //   .then((cognitoUser: any) => {
  //     return Auth.updateUserAttributes(cognitoUser, user);
  //   });
  // }

}